import { Item, ItemProperties } from './Item';
import { Field } from './Field';

/**
 * Effect type
 */
export type EffectType = 
  | 'Autofocus' | 'LensFlare' | 'Bloom' | 'BrightnessContrast' 
  | 'ChromaticAberration' | 'ColorAverage' | 'ColorDepth' | 'Depth' 
  | 'DepthOfField' | 'DotScreen' | 'Glitch' | 'GodRays' | 'Grid' 
  | 'HueSaturation' | 'Noise' | 'Outline' | 'Pixelation' | 'ScanlineEffect' 
  | 'SelectiveBloom' | 'Sepia' | 'SSAO' | 'SMAA' | 'FXAA' | 'Ramp' 
  | 'Texture' | 'ToneMapping' | 'Vignette' | 'ShockWave' | 'LUT' 
  | 'TiltShift' | 'TiltShift2' | 'ASCII' | 'Water' | 'SSR' | 'N8AO';

/**
 * Effect fields
 */
export const EffectFields: Field[] = [
  {
    key: 'properties.intensity',
    type: 'number',
    label: 'Intensity',
    default: 1,
    panel: 'effect',
  },
  {
    key: 'properties.enabled',
    type: 'boolean',
    label: 'Enabled',
    default: true,
    panel: 'effect',
  }
];

/**
 * Effect properties
 */
export interface EffectProperties extends ItemProperties {
  // Common properties for all effects
  intensity?: number;
  enabled?: boolean;
  blendFunction?: string;

  // Bloom specific
  luminanceThreshold?: number;
  luminanceSmoothing?: number;

  // ChromaticAberration specific
  offset?: number;

  // Noise specific
  opacity?: number;

  // DepthOfField specific
  focusDistance?: number;
  focalLength?: number;
  bokehScale?: number;

  // Glitch specific
  strength?: number;
  delay?: number;
  duration?: number;

  // Vignette specific
  darkness?: number;

  // SSAO specific
  radius?: number;
  luminanceInfluence?: number;

  // Pixelation specific
  granularity?: number;
}

/**
 * Effect item interface
 * 
 * @property type - The type of item
 * @property properties - The properties of the effect
 */
export interface Effect<P extends EffectProperties = EffectProperties> extends Item<P> {
  type: 'effect';
  subtype: EffectType;
  properties: P;
} 